// @ts-nocheck

import React, { useState, useEffect } from "react";
import axios from "axios";
// axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import PropTypes from "prop-types";
import { PageLoader } from "../../common/Loaders/PageLoader";
import { prefectures } from "../../../hooks/prefectures";
import { InfoBtn } from "../../common/Payment/InfoBtn";
import style from "./Dashboard.module.scss";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";

// NOTE: 請求書送付先メールアドレスはAPIが対応していないため､一旦コメントアウトで非表示にする
// 今後､Stripe API が追加で対応する可能性や別機能で同じようなUIを使うことも考慮して､UIコンポーネントは残す

export const EditBillings = ({ client, isPartner }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [name, setName] = useState(null);
  const [billingName, setBillingName] = useState(null);
  const [workspaceName, setWorkspaceName] = useState(null);
  const [zipCode, setZipCode] = useState(null);
  const [prefecture, setPrefecture] = useState("");
  const [city, setCity] = useState(null);
  const [street, setStreet] = useState(null);
  const [building, setBuilding] = useState(null);
  const [billingEmail, setBillingEmail] = useState(null);
  // const [billingEmailCC, setBillingEmailCC] = useState([]);
  const [errMessage, setErrMessage] = useState(null);
  const [notice, setNotice] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isZipCode, setIsZipCode] = useState(true);

  const zipCodeSearch = () => {
    if (!zipCode) {
      return;
    }
    if (!isZipCode) {
      return;
    }
    $.ajax({
      url: "https://zipcloud.ibsnet.co.jp/api/search",
      dataType: "jsonp", // jsonpを指定
      data: {
        zipcode: zipCode,
      },
      success: function (res) {
        if (res.status === 200) {
          if (res.results === null) {
            const err = { address: { zipCode: t("EditBillings.住所が見つかりませんでした") } };
            setErrMessage(err);
            return;
          }
          const data = res.results[0];
          setPrefecture(data.address1);
          setCity(data.address2);
          setStreet(data.address3);
          setErrMessage(null);
        } else {
          const err = { address: { zipCode: t("EditBillings.住所が見つかりませんでした") } };
          setErrMessage(err);
        }
      },
      error: function () {
        const err = { address: { zipCode: t("EditBillings.リクエストが失敗しました") } };
        setErrMessage(err);
      },
    });
  };

  const getBillings = async () => {
    await axios.get(`/${client}/settings/billing/retrieve`).then((res) => {
      const data = res.data;
      setName(data.company_name);
      setBillingName(data?.billing_name);
      setWorkspaceName(data.workspace_name);
      setZipCode(data.address?.postal_code);
      setPrefecture(data.address?.prefecture);
      setCity(data.address?.city);
      setStreet(data.address?.street);
      setBuilding(data.address?.building);
      setBillingEmail(data.billing_email);
      // setBillingEmailCC(data.billing_email_cc);
    });
    setLoading(false);
  };

  const submit = async (params) => {
    setIsSubmit(true);
    await axios
      .patch(`/${client}/settings/billing`, params)
      .then((res) => {
        setErrMessage(null);
      })
      .then(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        setNotice(true);
      });
    setIsSubmit(false);
  };

  const changeBillings = () => {
    setErrMessage(null);
    setNotice(false);
    const reg = new RegExp(/^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/);
    let err = {};
    if (isPartner) {
      if (!name || !workspaceName) {
        err = {
          name: !name ? t("EditBillings.会社名・名前は必須です") : null,
          workspaceName: !workspaceName ? t("EditBillings.ワークスペース名は必須です") : null,
          billingEmail: null,
          address: {},
        };
        setErrMessage(err);
        return;
      }
    } else {
      if (!name || !workspaceName || !billingEmail) {
        err = {
          name: !name ? t("EditBillings.会社名・名前は必須です") : null,
          workspaceName: !workspaceName ? t("EditBillings.ワークスペース名は必須です") : null,
          billingEmail: !billingEmail ? t("EditBillings.請求先メールアドレスは必須です") : null,
          address: {},
        };
        if (!zipCode || !prefecture || !city || !street) {
          if (!zipCode && !prefecture && !city && !street) {
            err.address = {};
            setErrMessage(err);
          } else {
            err.address = {
              zipCode: !zipCode ? t("EditBillings.請求先住所を入力する場合、郵便番号は必須です") : null,
              prefecture: !prefecture ? t("EditBillings.請求先住所を入力する場合、都道府県名は必須です") : null,
              city: !city ? t("EditBillings.請求先住所を入力する場合、市区町村は必須です") : null,
              street: !street ? t("EditBillings.請求先住所を入力する場合、町域・番地は必須です") : null,
            };
            setErrMessage(err);
          }
        }
        if (billingEmail && !billingEmail.match(reg)) {
          err["billingEmail"] = t("EditBillings.正しいメールアドレスの形式を入力してください");
        }
        setErrMessage(err);
        return;
      } else {
        if (!zipCode || !prefecture || !city || !street) {
          err = { address: {} };
          if (!zipCode && !prefecture && !city && !street) {
            err.address = {};
            setErrMessage(err);
            if (billingEmail && !billingEmail.match(reg)) {
              err["billingEmail"] = t("EditBillings.正しいメールアドレスの形式を入力してください");
              setErrMessage(err);
              return;
            }
          } else {
            err.address = {
              zipCode: !zipCode ? t("EditBillings.請求先住所を入力する場合、郵便番号は必須です") : null,
              prefecture: !prefecture ? t("EditBillings.請求先住所を入力する場合、都道府県名は必須です") : null,
              city: !city ? t("EditBillings.請求先住所を入力する場合、市区町村は必須です") : null,
              street: !street ? t("EditBillings.請求先住所を入力する場合、町域・番地は必須です") : null,
            };
            if (billingEmail && !billingEmail.match(reg)) {
              err["billingEmail"] = t("EditBillings.正しいメールアドレスの形式を入力してください");
            }
            setErrMessage(err);
            return;
          }
        } else {
          if (billingEmail && !billingEmail.match(reg)) {
            err["billingEmail"] = t("EditBillings.正しいメールアドレスの形式を入力してください");
            setErrMessage(err);
            return;
          }
        }
      }
    }

    const params = {
      company_name: name,
      workspace_name: workspaceName,
      address: {
        postal_code: zipCode,
        prefecture: prefecture,
        city: city,
        street: street,
        building: building,
      },
      billing_email: billingEmail,
      // billing_email_cc: billingEmailCC,
    };
    submit(params);
  };

  const changeZipCode = (e) => {
    const rex = new RegExp(/^[0-9]+$/);
    if (e.target.value.match(rex) || e.target.value === "") {
      setIsZipCode(true);
    } else {
      setIsZipCode(false);
    }
  };

  const initConnect = async () => {
    await getBillings();
  };

  useEffect(() => {
    initConnect();
  }, []);

  useEffect(() => {
    if (!billingName) {
      setBillingName(name);
    }
  }, [billingName]);

  useEffect(() => {
    const target = document.querySelector("#setting-content-main");

    if (errMessage && target) {
      target.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [errMessage]);

  return (
    <>
      {!loading ? (
        <>
          <div className={style.isPaymentModalWrap} style={{ display: notice ? "block" : "none" }}>
            <div className={`d-flex flex-column`}>
              <div className="d-flex align-items-center">
                <span>{t("EditBillings.請求先情報の更新が完了しました｡")}</span>
              </div>
            </div>
          </div>
          <div className="field" data-testid="edit-billings-content">
            <label className="required d-flex align-items-center">
              {t("EditBillings.会社名・名前")}
              <span className="ml-1 d-flex align-items-center" style={{ fontSize: 12, color: "#FF4958" }}>
                <img src={getImageUrl("images/icons/asterisk.svg")} alt="" />
                {t("EditBillings.必須")}
              </span>
            </label>
            <small className="text-muted mb-2" style={{ display: "block" }}>
              {t("EditBillings.※請求書や領収書の宛名として利用します｡")}
            </small>
            <input
              className={`form-control${errMessage?.name ? ` is-invalid` : ""}`}
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ backgroundImage: "none", width: 400 }}
            />
            {errMessage?.name && <div className="invalid-feedback">{errMessage.name}</div>}
          </div>

          <div className="field">
            <label className="required d-flex align-items-center">
              {t("EditBillings.ワークスペース名")}
              <span className="ml-1 d-flex align-items-center" style={{ fontSize: 12, color: "#FF4958" }}>
                <img src={getImageUrl("images/icons/asterisk.svg")} alt="" />
                {t("EditBillings.必須")}
              </span>
            </label>
            <input
              className={`form-control${errMessage?.workspaceName ? ` is-invalid` : ""}`}
              type="text"
              value={workspaceName}
              onChange={(e) => setWorkspaceName(e.target.value)}
              style={{ backgroundImage: "none", width: 400 }}
            />
            {errMessage?.workspaceName && <div className="invalid-feedback">{errMessage.workspaceName}</div>}
          </div>

          {!isPartner && (
            <div className="field">
              <label className="required d-flex align-items-center">
                {t("EditBillings.請求先メールアドレス")}
                <span className="ml-1 d-flex align-items-center" style={{ fontSize: 12, color: "#FF4958" }}>
                  <img src={getImageUrl("images/icons/asterisk.svg")} alt="" />
                  {t("EditBillings.必須")}
                </span>
              </label>
              <small className="text-muted mb-2" style={{ display: "block" }}>
                {t(
                  "EditBillings.※請求書送付先のメールアドレスを入力してください。メールアドレスは請求書にも記載されます｡",
                )}
              </small>
              <input
                className={`form-control${errMessage?.billingEmail ? ` is-invalid` : ""}`}
                type="email"
                value={billingEmail}
                onChange={(e) => setBillingEmail(e.target.value)}
                style={{ backgroundImage: "none", width: 400 }}
              />
              {errMessage?.billingEmail && <div className="invalid-feedback">{errMessage.billingEmail}</div>}
            </div>
          )}

          {!isPartner && (
            <div className="field">
              <label className="required">{t("EditBillings.請求先住所")}</label>
              <small className="text-muted mb-2" style={{ display: "block" }}>
                {t(
                  "EditBillings.※請求書に記載されます。空欄の場合は、請求書の住所欄が空欄になります｡請求書の送付はPDFのみです。郵送には対応しておりません。",
                )}
              </small>
              <div
                className="output-border-radius"
                style={{
                  background: "#fafafa",
                  border: "solid 1px #e6e6e6",
                  width: 664,
                  padding: "30px 30px 40px 30px",
                }}
              >
                <label className="required" style={{ color: "#777" }}>
                  {t("EditBillings.郵便番号")}
                </label>
                <div className="mb-4">
                  <div className="d-flex align-items-center">
                    <div className="d-flex flex-column">
                      <input
                        className={`form-control${errMessage?.address?.zipCode || !isZipCode ? ` is-invalid` : ""}`}
                        type="text"
                        value={zipCode}
                        maxLength="7"
                        onChange={(e) => setZipCode(e.target.value)}
                        onBlur={(e) => changeZipCode(e)}
                        style={{
                          width: "290px",
                          margin: 0,
                          backgroundImage: "none",
                        }}
                      />
                      {errMessage?.address?.zipCode && isZipCode ? (
                        <div className="invalid-feedback">
                          {errMessage?.address?.zipCode && errMessage.address.zipCode}
                        </div>
                      ) : (
                        !isZipCode && (
                          <div className="invalid-feedback">{t("EditBillings.半角数字のみ入力してください")}</div>
                        )
                      )}
                    </div>
                    <button
                      type="button"
                      className={`ml-2${errMessage?.address?.zipCode || !isZipCode ? ` align-self-start mt-1` : ""} ${
                        style.searchAddressBtn
                      }`}
                      onClick={() => zipCodeSearch()}
                    >
                      {t("EditBillings.住所検索")}
                    </button>
                  </div>
                  <small className="form-text text-muted mb-0">
                    {t("EditBillings.※半角数字で入力してください。ハイフンは不要です。")}
                  </small>
                </div>
                <div className="d-flex align-items-start justify-content-between mb-4">
                  <div>
                    <label className="required" style={{ color: "#777" }}>
                      {t("EditBillings.都道府県")}
                    </label>
                    <select
                      className={`form-control${errMessage?.address?.prefecture ? ` is-invalid` : ""}`}
                      value={prefecture}
                      onChange={(e) => setPrefecture(e.target.value)}
                      style={{
                        width: "290px",
                        margin: 0,
                        backgroundImage: "none",
                      }}
                    >
                      <option value="">{t("EditBillings.選択してください")}</option>
                      {prefectures.map((value, i) => (
                        <option key={i} value={value}>
                          {value}
                        </option>
                      ))}
                    </select>
                    {errMessage?.address?.prefecture && (
                      <div className="invalid-feedback">{errMessage.address.prefecture}</div>
                    )}
                  </div>
                  <div>
                    <label className="required" style={{ color: "#777" }}>
                      {t("EditBillings.市区町村")}
                    </label>
                    <input
                      className={`form-control${errMessage?.address?.city ? ` is-invalid` : ""}`}
                      type="text"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      style={{
                        width: "300px",
                        margin: 0,
                        backgroundImage: "none",
                      }}
                    />
                    {errMessage?.address?.city && <div className="invalid-feedback">{errMessage.address.city}</div>}
                  </div>
                </div>
                <div className="form-group">
                  <label className="required" style={{ color: "#777" }}>
                    {t("EditBillings.町域・番地")}
                  </label>
                  <input
                    className={`form-control${errMessage?.address?.street ? ` is-invalid` : ""}`}
                    type="text"
                    value={street}
                    onChange={(e) => setStreet(e.target.value)}
                    style={{ backgroundImage: "none" }}
                  />
                  {errMessage?.address?.street && <div className="invalid-feedback">{errMessage.address.street}</div>}
                </div>
                <div>
                  <label className="required" style={{ color: "#777" }}>
                    {t("EditBillings.マンション名・部屋番号")}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    value={building}
                    onChange={(e) => setBuilding(e.target.value)}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="actions">
            <InfoBtn
              text={t("EditBillings.保存")}
              loading={isSubmit}
              className="test-submit-card"
              submit={() => changeBillings()}
              style={{ fontWeight: 600 }}
            />
          </div>
        </>
      ) : (
        <PageLoader loadingHeight={"50vh"} />
      )}
    </>
  );
};

EditBillings.propTypes = {
  client: PropTypes.string,
  isPartner: PropTypes.bool,
};
